<template>
  <div id="bjzc-activity">
    <PageHeading>{{ $t('activity.name') }}</PageHeading>
    <div class="bjzc-activity-container bjzc-page-content">
      <div class="uk-flex-none">
        <Tabs v-model="view" :options="tabsOptions" @change="getList" />
      </div>
      <div class="uk-flex-1 border-radius">
        <div class="uk-search uk-search-default">
          <button class="uk-search-icon-flip" uk-search-icon @click="search"></button>
          <input
            v-model="keyword"
            class="uk-search-input"
            type="search"
            :placeholder="$t('activity.search')"
            @keypress.enter="search"
            @input="search"
          />
        </div>
        <div v-if="view === 'news'" class="bjzc-activity-news">
          <div v-for="item in list" :key="item.id" class="bjzc-activity-news-item" @click="handleItemClick(item)">
            <div class="uk-card uk-card-default uk-grid-collapse border-radius" uk-grid>
              <div class="uk-width-1-3 uk-width-1-4@s uk-card-media-left uk-cover-container">
                <img :src="$getLocaleValue(item, 'coverUrl')" alt="" uk-cover />
              </div>
              <div class="uk-width-expand">
                <div class="uk-card-body">
                  <h4 class="uk-text-truncate">{{ $getLocaleValue(item, 'title') }}</h4>
                  <p class="">
                    {{ $getLocaleValue(item, 'describe') }}
                  </p>
                  <span class="uk-visible@m">{{ item.createdAt.slice(0, 10) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="bjzc-activity-knowledge uk-child-width-1-3@m" uk-grid>
          <div v-for="item in list" :key="item.id" class="bjzc-activity-knowledge-item" @click="handleItemClick(item)">
            <div class="uk-cover-container border-radius">
              <img :src="item.coverUrl" alt="" uk-cover />
              <canvas height="195" width="340"></canvas>
              <!-- <span class="video-time">04:05</span> -->
            </div>
            <p>{{ item.title }}</p>
          </div>
        </div>

        <div v-if="list.length === 0">暂无相关动态</div>
      </div>
    </div>
  </div>
</template>

<script>
import { removeHtmlTag, debounce } from '../lib/util'
import Tabs from '../components/Tabs.vue'
export default {
  name: '',
  components: { Tabs },

  data() {
    return {
      view: 'news',
      categories: [],
      list: [],
      keyword: '',
      removeHtmlTag
    }
  },
  computed: {
    tabsOptions() {
      return [
        { name: this.$t('activity.news'), value: 'news', imagePath: 'activity/news.png' },
        { name: this.$t('activity.legal'), value: 'legal', imagePath: 'activity/legal.png' }
      ]
    }
  },
  created() {
    this.getCategories()
    this.$eventBus.$emit('setBreadcrumb', [
      { path: '/', title: '首页', title_en: 'Home' },
      {
        path: '/activity',
        title: this.$t('breadcrumb.activity', 'zh'),
        title_en: this.$t('breadcrumb.activity', 'en')
      }
    ])
  },
  methods: {
    handleItemClick(item) {
      this.$router.push({
        name: 'ActivityDetail',
        params: {
          id: item.id
        }
      })
    },
    getCategories() {
      this.$axios.get('categories').then(res => {
        this.categories = res.data
        this.getList()
      })
    },
    getList() {
      this.$axios.get('articles', { params: { kind: this.view, keyword: this.keyword } }).then(res => {
        this.list = res.data
      })
    },
    search: debounce(function () {
      this.getList()
    }, 300)
  }
}
</script>

<style lang="scss">
#bjzc-activity {
  min-height: 500px;
  .bjzc-activity-container {
    display: flex;
    & > :nth-child(2) {
      padding: 0 2.5rem 2.5rem;
      background-color: #fff;
    }
  }
  .bjzc-activity-news {
    padding-top: 1.25rem;
    .bjzc-activity-news-item {
      & + .bjzc-activity-news-item {
        margin-top: 0.69rem;
      }
      .uk-card {
        box-shadow: none;
        border: 1px solid #dcdfe6;
        cursor: pointer;

        transition: color 0.1s;
        &:hover {
          .uk-card-body h4 {
            color: $color-primary;
          }
          border-color: $color-primary;
        }
      }
      .uk-card-media-left {
        // width: 10rem;
        min-height: 5rem;
      }
      .uk-card-body {
        padding: 1.25rem;
        padding-bottom: 0.69rem;
        p {
          font-size: 0.88rem;
          margin: 0.75rem 0;
          display: -webkit-box;
          height: 2.5rem;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        span {
          font-size: 0.75rem;
        }
      }
    }
  }

  .bjzc-activity-knowledge {
    padding-top: 1.25rem;
    .bjzc-activity-knowledge-item {
      cursor: pointer;
      .video-time {
        font-size: 0.75rem;
        font-weight: 500;
        color: #fff;
        position: absolute;
        left: 0.5rem;
        bottom: 0.25rem;
      }
      p {
        margin-top: 10px;
        font-weight: 500;
      }
      &:hover p {
        color: $color-primary;
      }
    }
  }

  .uk-search {
    .uk-search-input {
      background-color: #fafcff;
      border-color: #dcdfe6;
      padding-left: 8px;
      font-size: 13px;
      height: 28px;
      line-height: 28px;
      border-radius: 4px;
    }
    .uk-search-icon-flip {
      background-color: #fff;
      top: 1px;
      bottom: 1px;
      right: 1px;
      width: 28px;
      border-left: 1px solid #dcdfe6;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      cursor: pointer;
      &:hover {
        svg {
          color: $color-primary;
        }
      }
      svg {
        width: 18px;
        height: 18px;
      }
    }
  }
}

@media (max-width: ($screen-width-m - 1)) {
  #bjzc-activity {
    .bjzc-activity-container {
      flex-direction: column;
      & > :nth-child(2) {
        padding: 0;
      }
    }
    .bjzc-activity-news {
      .bjzc-activity-news-item {
        .uk-card-body {
          padding: 1rem 0.5rem 1rem 0.75rem;
          h4 {
            font-size: 0.88rem;
            margin: 0;
          }
          p {
            font-size: 0.75rem;
            margin: 0.75rem 0 0;
          }
        }
      }
    }
  }
}
</style>
